export type ResolveLibrary<T> = (library?: T) => void;
export type RejectLibrary = (reason?: unknown) => void;
export type ExecuteWithLibrary<T> = <Result>(cb: (library: T) => Result) => Promise<Result>;
export const executeWithDeferredLibrary = <T>(): [resolver: ResolveLibrary<T>, executor: ExecuteWithLibrary<T>, rejecter: RejectLibrary] => {
  let resolveLibrary: ResolveLibrary<T> = () => {};
  let rejectLibrary: RejectLibrary = () => {};
  const loadedLibraryPromise: Promise<T> = new Promise((resolve, reject) => {
    resolveLibrary = resolve as ResolveLibrary<T>;
    rejectLibrary = reject;
  });
  // Prevent unhandled rejection when rejecter is called before any .then() is attached
  // (e.g. chunk fails during preload before any withClient() call). Actual rejections
  // are still propagated to callers via executeWithLibrary's .then() chain.
  loadedLibraryPromise.catch(() => {});
  const executeWithLibrary: ExecuteWithLibrary<T> = cb => {
    return loadedLibraryPromise.then(cb);
  };

  return [resolveLibrary, executeWithLibrary, rejectLibrary];
};
